(ns common.db.effects.clipboard
  (:require [goog.dom :as gdom]
            [goog.style :as gstyle]
            [re-frame.core :as rf]))

(defn text-area-yank
  ([content] (text-area-yank content nil nil))
  ([content success] (text-area-yank content success nil))
  ([content success error]
   (let [el (doto (gdom/createElement "textarea")
              (gdom/setTextContent content)
              (gstyle/setStyle "position" "absolute")
              (gstyle/setPosition -10000))]
     (gdom/appendChild (.-body js/document) el)
     (.select el)
     (let [copied (js/document.execCommand "copy")]
       (.remove el)
       (cond (and copied (fn? success))
             (success)
             (and (not copied) (fn? error))
             (error))))))

(defn browser-api-yank
  ([content] (browser-api-yank content nil nil))
  ([content success] (browser-api-yank content success nil))
  ([content success error]
   (-> (.-clipboard js/navigator)
       (.writeText content)
       (.then success)
       (.catch error))))

(defn content->clipboard
  "NOTE:
  If this effect has to use the old-skool-klippy method (i.e. only IE) then
  this effect won't work (permission-wise) via dispatch, only
  dispatch-sync.
  For any other browser it will work correctly with dispatch"
  [{:keys [content success error]}]
  (if (and js/navigator (.-clipboard js/navigator))
    (browser-api-yank content success error)
    (text-area-yank content success error)))

(rf/reg-fx :content->clipboard
  content->clipboard)
